<template>
	<section id="today" class="container">
		
		

		<b-overlay
		v-if="loading"
		:show="loading"
		variant="light"
		opacity="0.9"
		blur
		rounded="sm"
		spinner-variant="primary"
		class="custom-modal-overlay"
		>
			<template #overlay>
				<div class="text-center p-4 bg-white rounded shadow-lg modal-content-style">
					<p id="cancel-label" class="mb-2">Generando graficas...</p>
					<b-progress
						:value="progressValue"
						max="100"
						height="1.5rem"
						animated
						striped
						variant="primary"
						class="mb-3"
					></b-progress>

					<b-button
						ref="cancel"
						variant="outline-danger"
						size="sm"
						aria-describedby="cancel-label"
						@click="stopped = true"
					>
						Cancel
					</b-button>
				</div>
			</template>
		</b-overlay>


		<b-overlay :show="loadingToday" rounded="sm">
<!-- 			<b-card-group deck>
				<Card title="Total Rides" :value="resumeToday.ridesTotal" />
				<Card
					title="Rides Programados"
					:value="resumeToday.ridesProgrammed"
				/>
				<Card title="Completados" :value="resumeToday.ridesDone" />
				<Card title="No shows" :value="resumeToday.ridesNoShow" />
				<Card title="Success Rate" :value="resumeToday.successRate" />
			</b-card-group> -->
			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesTotal }}</b>
						</h2>
						<h4 class="text-success">Total Rides</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesProgrammed }}</b>
						</h2>
						<h4 class="text-success">Rides Programados</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesDone }}</b>
						</h2>
						<h4 class="text-success">Completados</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesNoShow }}</b>
						</h2>
						<h4 class="text-success">No shows</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.successRate }}%</b>
						</h2>
						<h4 class="text-success">Success Rate</h4>
					</b-card-text>
				</b-card>
			</b-card-group>
		</b-overlay>

		<div class="container mt-3">
			<b-card border-variant="success" align="center"  v-for="(chart,index) in chartList.slice(0, shownChartsCount)" class="mb-2" :key="index" >
				<component
					:key="chart"
					:is="chart"
					:filters="filters"
					:triggerSearch="triggerSearch"
					@finished="onChartFinished"
				/>
			</b-card>
		</div>
		
	</section>
</template>

<script>
import api from "../../../../api.js";
//import Card from "./cards.vue";
import ChartPerSalesChannel from "../charts/operations/RidesPerSalesChannel";
import ChartVehicleType from "../charts/operations/RidesPerVehicleType";
import ChartPerSupplier from "../charts/operations/RidesPerSupplier";
import ChartPerStatus from "../charts/operations/RidesPerStatus";
import ChartPerAirport from "../charts/operations/RidesPerAirport";
import ChartPerSchedule from "../charts/operations/RidesPerSchedule";
import ChartAveragePaxPerVehicle from "../charts/operations/AveragePaxPerVehicleType";
import ChartAverageStatusContact from "../charts/operations/AverageStatusContact";
import ChartAverageTripType from "../charts/operations/AverageTripType";
import ChartPerPos from "../charts/operations/RidesPerPointOfSale";
import ChartPerSupplierTime from "../charts/operations/RidesPerSupplierByTime";
import ChartProfitAverage from "../charts/operations/AverageProfitPerVehicle.vue";
import SmsSent from "../charts/operations/SmsSent";

export default {
	props: {
		filters: {
			type: Object,
			required: true
		},
		triggerSearch: {
			type: Number,
			required: true
		}
	},
	components: {
		//Card,
		ChartPerSalesChannel,
		ChartVehicleType,
		ChartPerSupplier,
		ChartPerStatus,
		ChartPerAirport,
		ChartPerSchedule,
		ChartAveragePaxPerVehicle,
		ChartAverageStatusContact,
		ChartAverageTripType,
		ChartPerPos,
		SmsSent,
		ChartPerSupplierTime,
		ChartProfitAverage
	},
	name: "Operations",
	data() {
		return {
			loaded: false,
			loadingToday: false,
			resumeToday: {
				ridesTotal: 0,
				ridesProgrammed: 0,
				ridesDone: 0,
				ridesNoShow: 0,
				successRate: 0
			},
			shownChartsCount:0,
			chartList: [
				"ChartProfitAverage",
				"ChartPerSupplierTime",
				"ChartPerPos",
				"ChartPerStatus",
				"ChartPerSalesChannel",
				"ChartPerSchedule",
				"ChartVehicleType",
				"ChartPerAirport",
				"ChartAveragePaxPerVehicle",
				"ChartPerSupplier",
				"ChartAverageStatusContact",
				"ChartAverageTripType",
				"SmsSent",
				
			],
			stopped:false,
		};
	},
	methods: {
		getResumeToday() {
			this.loadingToday = true;
			api(this)
				.get(`/dashboard/operations/resume`)
				.then(res => {
					this.resumeToday = res.data;
				})
				.catch(this.handleModelError)
				.finally(() => {
					this.loadingToday = false;
					//this.loaded = true;
				});
		},
		startNextChart() {
			if (this.shownChartsCount < this.chartList.length && !this.stopped) {
				this.shownChartsCount++;
			}
		},
		onChartFinished() {
			this.startNextChart();
		}
	},
	computed: {
		loading() {
			return (this.shownChartsCount < this.chartList.length && (!this.stopped) && this.shownChartsCount !=0);
		},
		progressValue() {
			if (!this.chartList.length) return 0;
			return Math.round((this.shownChartsCount / this.chartList.length) * 100);
		}
	},
	watch: {
		triggerSearch() {
			this.stopped=false;
			this.shownChartsCount = 0;
			this.startNextChart(); // Start from the beginning again
		}
	},
	mounted() {
		this.getResumeToday();
	}
};
</script>

<style>
.custom-modal-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1050; /* like modals */
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content-style {
  min-width: 300px;
  max-width: 400px;
}

</style>
